module.exports = {
  "zones": {
    "Antarctica/Davis": ["z", {
      "wallclock": 1329872400000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 1329854400000,
      "save": 0
    }, {
      "wallclock": 1319767200000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": 1319742000000,
      "save": 0
    }, {
      "wallclock": 1268269200000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 1268251200000,
      "save": 0
    }, {
      "wallclock": 1255831200000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": 1255806000000,
      "save": 0
    }, {
      "wallclock": -28857600000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -28857600000,
      "save": 0
    }, {
      "wallclock": -163036800000,
      "format": "-00",
      "abbrev": "-00",
      "offset": 0,
      "posix": -163062000000,
      "save": 0
    }, {
      "wallclock": -409190400000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -409190400000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "-00",
      "abbrev": "-00",
      "offset": 0,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};